<template>
  <div>
    <b-modal
      id="modal-invoice-act"
      ref="modal_invoice_act"
      title="Акт"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
    >
      <b-form>
        <b-row cols-lg="4" cols-md="2" cols="1">
          <b-col>
            <b-form-group label="Акт №">
              <b-form-input
                id="input_numb"
                size="sm"
                autocomplete="off"
                v-model.number="newItem.numb"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Дата">
              <b-form-input
                id="input-date"
                size="sm"
                type="date"
                v-model.date="newItem.date"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Договор (№ и Дата)">
              <b-form-input
                id="input-contract"
                size="sm"
                autocomplete="off"
                v-model="newItem.contract"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Место составления (Город)">
              <b-form-input
                id="input-town"
                size="sm"
                autocomplete="off"
                v-model="newItem.town"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <!--  Работы  -->
      <b-card class="custom-card">
        <div class="d-flex align-items-center w-100">
          <h5>Работы</h5>
          <b-button variant="link" @click.stop="onAddWork()">
            <v-icon name="buttons/plus" :size="10" class="mr-1"/>
            Добавить
          </b-button>
        </div>

        <div class="page-body">
          <div class="page-table-container">
            <b-table
              id="invoice-works"
              ref="invoice-works"
              class="custom-table mb-0"
              selectable
              select-mode="single"
              responsive
              show-empty
              :empty-text="$t('message.common.emptyTable')"
              :items="newItem.works"
              :fields="worksFields"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"/>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>

              <template #cell(work_type_id)="row">
                <b-form-select
                  id="input_work_type"
                  size="sm"
                  v-model="row.item.work_type_id"
                  :options="work_type_catalogs"
                />
              </template>

              <template #cell(name)="row">
                <b-form-input
                  id="input_name"
                  size="sm"
                  autocomplete="off"
                  v-model="row.item.name"
                />
              </template>

              <template #cell(price)="row">
                <b-form-input
                  id="input_price"
                  size="sm"
                  class="widthPrice"
                  autocomplete="off"
                  v-model.number="row.item.price"
                />
              </template>

              <template #cell(count)="row">
                <b-form-input
                  id="input_count"
                  size="sm"
                  class="widthPrice"
                  autocomplete="off"
                  v-model.number="row.item.count"
                />
              </template>

              <template #cell(nds)="row">
                {{ row.item.nds }}%
              </template>

              <template #cell(unit)="row">
                <unit-select id="input_unit" ref="unit_select" :initial-unit="row.item.unit_code" is-short @selectUnit="updateUnit($event, row)" />
              </template>

              <template #cell(summa)="row">
                {{priceFormat(row.item.summa)}}
              </template>

              <template #cell(action)="row">
                <b-button variant="link" @click="removeWork(row)">
                  <v-icon name="buttons/trash" :size="16"/>
                </b-button>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="newItem.works.length"
              :per-page="worksPerPage"
              :current-page.sync="worksCurrentPage"
              @per-page-change="onPerPageChange"
            >
              <template #footer-list>
                Всего работ: <b>{{this.newItem.works.length}}</b> |
              </template>
            </pagination-footer>
          </div>
        </div>
      </b-card>

      <template #modal-footer>
        <b-button class="custom-btn-secondary mr-2" @click="hideModal()">
          Отменить
        </b-button>
        <b-button class="custom-btn-primary" @click="onOK()">
          Сохранить
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import unitStore from "../../utilites/unitStore";
    import UnitSelect from "../Catalogs/UnitSelect";
    import ExportFile from "./ExportFile";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "InvoiceAct",
  components: {PaginationFooter, UnitSelect, ExportFile },
  mixins: [
    catalogs,
    helpers, dateFormatter, unitStore
  ],
  data() {
    return {
      newItem: {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        contract: '',
        town: '',
        active: true,
        works: [],
        sum: 0
      },
      nds: 0,
      work_type_catalogs: [],
      worksPerPage: 10,
      worksCurrentPage: 1,
      worksFields: [
        {
          key: 'index',
          label: '№',
          class: 'widthIndex',
        },
        {
          key: 'work_type_id',
          label: 'Вид работ',
          class: 'widthCatalog',
        },
        {
          key: 'name',
          label: 'Наименование',
          sortable: true,
        },
        {
          key: 'price',
          label: 'Цена',
          class: 'widthPrice',
        },
        {
          key: 'count',
          label: 'Количество',
          class: 'widthPrice',
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: 'widthPrice',
        },
        {
          key: 'nds',
          label: 'НДС',
          class: 'widthPrice',
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom'
        },
      ],
      completion: null,
    }
  },
  async created() {
    this.work_type_catalogs = await this.getWorkTypeCatalogOptions();
  },
  methods: {
    showModal(act, nds, completion) {
      this.completion = completion;
      this.nds = nds;

      if (act != null) {
        this.newItem = act;
      } else {
        this.newItem = {
          id: 0,
          numb: 0,
          date: this.formatDate(new Date()),
          contract: '',
          town: '',
          active: true,
          works: [],
        }
      }

      this.$refs.modal_invoice_act.show();
    },
    hideModal() {
      this.$refs.modal_invoice_act.hide();
    },
    onOK() {
      this.hideModal();

      if (this.completion) {
        this.newItem.sum = this.newItem.works
          .map(obj => obj.sum)
          .reduce((acc, current) => acc + current, 0);

        this.completion(this.newItem);
      }
    },
    onAddWork() {
      const index = this.newItem.works.length + 1;
      const work = {
        sort_index: index,
        id: 0,
        work_type_id: null,
        name: '',
        price: null,
        count: null,
        unit_code: '539',
        nds: this.nds,
        sum: null
      };
      this.newItem.works.push(work);
    },
    removeWork(row) {
      this.newItem.works.splice(row.index,1);
    },
    async getWorkTypeCatalogOptions(data) {
      const result = await this.getWorkTypeCatalogs(data);
      const catalogs = result.data ? result.data.items : null;

      return catalogs
        .sort((x, y) => (Number(y.active) - Number(x.active)))
        .map(e => ({ value: e.id, text: e.name, disabled: !e.active }));
    },
    // Единицы измерения
    updateUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    onPerPageChange(newPerPage) {
      this.worksPerPage = Number(newPerPage);
      this.worksCurrentPage = 1;
    },
  },
  watch: {
    'newItem.works': {
      handler: function (newValues, _) {
        newValues.forEach(function (tw) {
          tw.sum = tw.count * tw.price;
        }.bind(this));

        this.newItem.summa = this.totalPriceWorks;
      },
      deep: true
    },
  }
}
</script>

<style>
#modal-invoice-act .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}

#footer {
  position: sticky;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceAct.vue